// Column definitions for the four read-only result grids, in the legacy grid order
// (uWMD0088.dfm grdSummary / grdDetail / grdCustomer / AbGrid1).
//
// dataField casing is PascalCase because the endpoints serialise with DefaultContractResolver.
//
// dataType is declared on EVERY column, deliberately. DevExtreme only infers it from the first
// non-null value, and these are stored-procedure result sets where a whole column can legitimately
// come back empty — the management units in particular, since Department / Job / Fund are optional on
// a charge code. With nothing to infer from, the column gets no filter-row editor and no search icon,
// so the user loses the ability to filter it. Declaring the type makes the grid deterministic
// regardless of what the calculation happens to return.
//
// Money uses the "$ #,##0.00" mask; the other numerics use the fixedPoint object form. dataType
// "number" also right-aligns automatically, matching the legacy taRightJustify titles.

const MONEY_FORMAT = "$ #,##0.00";
const TWO_DECIMAL_FORMAT = { type: "fixedPoint", precision: 2, useGrouping: true };

const TEXT = "string";
const NUMBER = "number";

export const SUMMARY_COLUMNS = [
    { dataField: "Account", caption: "Account", dataType: TEXT },
    { dataField: "Activity", caption: "Activity", dataType: TEXT },
    { dataField: "Department", caption: "Department", dataType: TEXT },
    { dataField: "Job", caption: "Job", dataType: TEXT },
    { dataField: "Fund", caption: "Fund", dataType: TEXT },
    { dataField: "Amount", caption: "Amount", dataType: NUMBER, format: MONEY_FORMAT },
];

export const DETAIL_COLUMNS = [
    { dataField: "IdentityId", caption: "Customer", dataType: TEXT },
    { dataField: "ItemCode", caption: "Item Code", dataType: TEXT },
    { dataField: "LotCode", caption: "Lot Code", dataType: TEXT },
    { dataField: "Account", caption: "Account", dataType: TEXT },
    { dataField: "Activity", caption: "Activity", dataType: TEXT },
    { dataField: "Department", caption: "Department", dataType: TEXT },
    { dataField: "Job", caption: "Job", dataType: TEXT },
    { dataField: "Fund", caption: "Fund", dataType: TEXT },
    { dataField: "Amount", caption: "Amount", dataType: NUMBER, format: MONEY_FORMAT },
    { dataField: "OnHand", caption: "On Hand", dataType: NUMBER, format: TWO_DECIMAL_FORMAT },
    { dataField: "Rate", caption: "Rate", dataType: NUMBER, format: MONEY_FORMAT },
    { dataField: "DeferredRevenuePercent", caption: "Deferred Revenue %", dataType: NUMBER, format: TWO_DECIMAL_FORMAT },
    { dataField: "ChargeCode", caption: "Charge Code", dataType: TEXT },
];

export const BY_CUSTOMER_COLUMNS = [
    { dataField: "IdentityId", caption: "Customer", dataType: TEXT },
    { dataField: "Name", caption: "Name", dataType: TEXT },
    { dataField: "Amount", caption: "Amount", dataType: NUMBER, format: MONEY_FORMAT },
];

export const BY_CUSTOMER_DEPT_COLUMNS = [
    { dataField: "IdentityId", caption: "Customer", dataType: TEXT },
    { dataField: "Name", caption: "Name", dataType: TEXT },
    { dataField: "Department", caption: "Department", dataType: TEXT },
    { dataField: "Amount", caption: "Amount", dataType: NUMBER, format: MONEY_FORMAT },
];
